import gql from "graphql-tag";




export const allShipments = gql`
  query allShipments(
    $archived: Boolean
    $loadingDateAfter: Date
    $loadingDateBefore: Date
  ) {
    allShipments(
      condition: { archived: $archived }
      filter: {
          date: {
            greaterThanOrEqualTo: $loadingDateAfter
            lessThanOrEqualTo: $loadingDateBefore
          }
        }
    ) {
      nodes {
        id
        selected
        date
        about
        status
        archived
        carrierId
        relationId
        cargoTypeId
        createdAt
        updatedAt
        storagesByShipmentId {
          nodes {
            id
            fileName
            fileSize
            fileType
            url
          }
        }
        carrierByCarrierId {
          id
          truck
          trailer
          driver1Tel
          driver2Tel
          type
          emptyWeight
          trolleysSection1
          trolleysSection2
          about
        }
        relationByRelationId {
          id
          name
          color
        }
        cargoTypeByCargoTypeId {
          id
          type
          code
        }
      }
    }
  }
`;

export const createShipment = gql`
  mutation(
    $selected: Boolean
    $date: Date
    $about: String
    $carrierId: Int
    $status: JSON
    $relationId: Int
    $archived: Boolean
    $cargoTypeId: Int
    $createdAt: Datetime
    $updatedAt: Datetime
  ) {
    createShipment(
      input: {
        shipment: {
          selected: $selected
          date: $date
          about: $about
          status: $status
          carrierId: $carrierId
          relationId: $relationId
          archived: $archived
          cargoTypeId: $cargoTypeId
          createdAt: $createdAt
          updatedAt: $updatedAt
        }
      }
    ) {
      shipment {
        id
      }
    }
  }
`;

export const updateShipmentById = gql`
  mutation(
    $id: Int!
    $selected: Boolean
    $date: Date
    $about: String
    $carrierId: Int
    $relationId: Int
    $archived: Boolean
    $cargoTypeId: Int
    $status: JSON
  ) {
    updateShipmentById(
      input: {
        id: $id
        shipmentPatch: {
          selected: $selected
          date: $date
          about: $about
          carrierId: $carrierId
          relationId: $relationId
          archived: $archived
          cargoTypeId: $cargoTypeId
          status: $status
        }
      }
    ) {
      shipment {
        id
        selected
        date
        about
        carrierId
        relationId
        archived
        cargoTypeId
        status
      }
    }
  }
`;

export const deleteShipmentById = gql`
  mutation deleteShipmentById($id: Int!) {
    deleteShipmentById(input: { id: $id }) {
      deletedShipmentId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/shipments.js